// eslint-disable-next-line @typescript-eslint/naming-convention
export enum mentionAttributeTypesEnum {
    savedBy,
    savedDate,
    lastModifiedBy,
    lastModifiedDate,
    tags,
    folders,
    sentiment,
    audienceReach,
    adValueUsd,
    mediaType,
    location,
    wordCount,
    duration,
    domainAuthority,
    language,
    url,
    license,
    outlet,
    publishedDate
}
